import { History } from 'history'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'
import { ApplicationInsights, ITelemetryPlugin } from '@microsoft/applicationinsights-web'

import { BASIC_ROOT_ROUTE } from 'Core/constants'
import { PAGE_TITLE } from 'Core/interfaces'

import { INITIAL_PAGE_NAME } from './constants'

let reactPlugin: ITelemetryPlugin | null = null
let appInsights: ApplicationInsights | null = null

/**
 * Create the App Insights Telemetry Service
 * @return {{reactPlugin: ReactPlugin, appInsights: Object, initialize: Function}} - Object
 */
const createTelemetryService = () => {
	/**
	 * Initialize the Application Insights class
	 * @param {Object} browserHistory - client's browser history
	 * @param {string} connectionString - Application Insights Instrumentation Key
	 * @param {string} userName - userName for Application Insights
	 * @return {void}
	 */
	const initialize = (
		browserHistory: History,
		connectionString: BasicString,
		userName: string
	) => {
		if (!browserHistory) {
			throw new Error('Could not initialize Telemetry Service')
		}

		if (!connectionString) {
			// eslint-disable-next-line no-console
			console.error('Please provide ConnectionString')
			return
		}

		reactPlugin = new ReactPlugin() as unknown as ITelemetryPlugin

		if (!reactPlugin) {
			throw new Error('React Plugin was not loaded')
		}

		appInsights = new ApplicationInsights({
			config: {
				connectionString,
				maxBatchInterval: 0,
				disableFetchTracking: true,
				extensions: [reactPlugin],
				autoTrackPageVisitTime: false,
				enableAutoRouteTracking: false,
				enableRequestHeaderTracking: false,
				enableResponseHeaderTracking: false,
				enableAjaxPerfTracking: false,
				disableAjaxTracking: true,
				extensionConfig: {
					[reactPlugin.identifier]: {
						history: browserHistory
					}
				}
			}
		})

		try {
			appInsights.loadAppInsights()
			appInsights.setAuthenticatedUserContext(userName)
			if (browserHistory.location.pathname === BASIC_ROOT_ROUTE) {
				appInsights.trackPageView({
					name: INITIAL_PAGE_NAME
				})
			}
			appInsights.addTelemetryInitializer((item) => {
				if (item.baseData?.name === PAGE_TITLE) {
					return false
				}
			})
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error(error)
		}
	}

	return { reactPlugin, appInsights, initialize }
}

export const ai = createTelemetryService()
export const getAppInsights = () => appInsights
